import { createTheme } from "@mui/material";

export const createCustomTheme = (element: HTMLElement) => {
  const themes = createTheme({});

  return createTheme(themes, {
    palette: {
      primary: {
        light: "rgba(13, 146, 210, 0.2)", // opacity 20%,
        main: "#0d92D2",
        // dark: will be calculated from palette.primary.dark,
        // contrastText: will be calculated to contrast with palette.primary.contrastText
      },
      secondary: {
        // light: will be calculated from palette.secondary.light,
        main: "#ff6700",
        // dark: will be calculated from palette.secondary.dark,
        contrastText: "#fff",
      },
      grey: {
        light: "#f3f3f3",
        main: "#c0c0c0",
      },
      darkblue: {
        light: "rgba(5, 57, 82, 0.05)", // opacity 5%
        main: "#053952",
      },
      blackBackground: {
        main: "rgba(0, 0, 0, 0.7)", // opacity 70%
      },
      whiteBackground: {
        main: "rgba(255,255,255, 0.3)", // opacity 30%
        dark: "rgba(255,255,255, 0.6)", // opacity 60%
      },
    },
    typography: {
      fontFamily: "Roboto",
      h1: {
        fontFamily: "Roboto",
        fontWeight: 500,
        fontSize: "72px",
        lineHeight: "96px",
        letterSpacing: 0,
      },
      h2: {
        fontFamily: "Roboto",
        fontWeight: 500,
        fontSize: "51px",
        lineHeight: "72px",
        letterSpacing: 0,
      },
      h3: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "36px",
        lineHeight: "48px",
        letterSpacing: 0,
      },
      h4: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "20px",
        lineHeight: "26px",
        letterSpacing: 0,
      },
      h5: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: 0,
      },
      h6: {
        fontFamily: "Roboto",
        fontWeight: 300,
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: 0,
      },
      subtitle1: {
        fontFamily: "Roboto",
      },
      subtitle2: {
        fontFamily: "Roboto",
      },
      body1: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: 0,
      },
      body2: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "18px",
        letterSpacing: 0,
      },
      button: {
        fontFamily: "Roboto",
      },
      caption: {
        fontFamily: "Roboto",
        fontWeight: 300,
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: 0,
      },
      overline: {
        fontFamily: "Roboto",
      },
    },
    components: {
      MuiPopover: {
        defaultProps: {
          container: element,
        },
      },
      MuiPopper: {
        defaultProps: {
          container: element,
        },
      },
      MuiModal: {
        defaultProps: {
          container: element,
        },
      },
      MuiDrawer: {
        defaultProps: {
          container: element,
        },
      },
    },
  });
};
